import React, { useEffect, useState } from 'react';
import styles from './NewsPage.module.scss';
import NewsTopHeader from '../../Molecules/TableTopHeader/NewsTopHeader';
import { useFetchMedia } from '../../../Hooks/Media';
import MediaCard from '../../Molecules/NewsAndEvents/MediaCard';
import CreateAlbumModal from '../../Molecules/NewsAndEvents/CreateAlbumModal';
import Loader from '../../Molecules/Loader/Loader';
import NoDataComponent from '../../Molecules/Custom/NoDataComponent/NoDataComponent';
import { debounce } from 'lodash';

const MediaPage = () => {
  const [search, setSearch] = useState('');
  const {
    data: media,
    refetch: refetchMedia,
    isLoading,
  } = useFetchMedia(search);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    handleSearch();
  }, [search]);

  const handleSearch = debounce(() => {
    refetchMedia();
  }, 300);
  const albumsCount = Array.isArray(media?.data) ? media.data.length : 0;

  return (
    <div>
      <NewsTopHeader
        handleNewClick={() => setShowCreateModal(true)}
        type='media'
        search={search}
        setSearch={setSearch}
      />
      <div className={styles['table-container']}>
        {isLoading ? (
          <Loader />
        ) : media?.data?.length > 0 ? (
          <div className={styles['media-box-grid']}>
            {media?.data?.map((item) => (
              <MediaCard
                media={item}
                refetchMedia={refetchMedia}
                key={item?.mediaGalleryId}
                albumsCount={albumsCount}
              />
            ))}
          </div>
        ) : (
          <NoDataComponent />
        )}
      </div>
      {showCreateModal && (
        <CreateAlbumModal
          handleOnClose={() => setShowCreateModal(false)}
          refetch={refetchMedia}
          albumsCount={albumsCount}
        />
      )}
    </div>
  );
};

export default MediaPage;
